@if (!isResult) {
  <div class="wm-seleniumactionartifact-description" >
    @switch (commandName) {
      @case ('FancyCommandThatDoesntExistYet') {
        <!-- refer to command specific component here -->
      }
      @case ('FindElements') {
        <em>FindElements</em>({{actionData.locationStrategy}}={{actionData.selector}})
      }
      @case ('ElementClick') {
        <em>ElementClick</em>(element={{actionData.elementId}})
      }
      @case ('FindElement') {
        <em>FindElement</em>({{actionData.locationStrategy}}={{actionData.selector}})
      }
      @case ('IsElementDisplayed') {
        <em>IsElementDisplayed</em>(element={{actionData.elementId}})
      }
      @case ('IsElementEnabled') {
        <em>IsElementEnabled</em>(element={{actionData.elementId}})
      }
      @case ('IsElementClickable') {
        <em>IsElementClickable</em>(element={{actionData.elementId}})
      }
      @case ('NavigateTo') {
        <em>NavigateTo</em>({{actionData.url}})
      }
      @case ('ExecuteScript') {
        <em>ExecuteScript</em>(async={{actionData.async}})
      }
      @case ('GenericSeleniumCommand') {
        <em>GenericSeleniumCommand</em>({{actionData.name}})
      }
      @default {
        {{commandName}}
      }
    }
  </div>
}
@if (isResult) {
  @if (isError()) {
    <div class="wm-seleniumactionartifact-description">{{resultData?.type}} ERROR: {{errorMsg}}</div>
  }
  @if (!isError()) {
    <div class="wm-seleniumactionartifact-description">
      <div>
        @switch (resultData?.type) {
          @case ('FindElementsResult') {
            FindElements: Id {{resultData['elements']}}
          }
          @case ('ElementClickResult') {
            ElementClick successful
          }
          @case ('FindElementResult') {
            FindElement: Id {{resultData['elementId']}}
          }
          @case ('IsElementDisplayedResult') {
            IsElementDisplayed: {{resultData['displayed']}}
          }
          @case ('IsElementEnabledResult') {
            IsElementEnabled: {{resultData['enabled']}}
          }
          @case ('IsElementClickableResult') {
            IsElementClickable: {{resultData['clickable']}}
          }
          @case ('NavigateToResult') {
            NavigateTo successful
          }
          @case ('ExecuteScriptResult') {
            ExecuteScript successful
          }
          @default {
            {{resultData?.type}} {{objectWithoutTypeField(resultData) | json}}
          }
        }
      </div>
    </div>
  }
}


